import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

const BIOMETRIC_PATH = 'biometrics'

export function getDetailBiometricByUserId(userId, id) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${BIOMETRIC_PATH}/getByUserId`, {
            params: {
                userId,
                id,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function createOrUpdateBiometric(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${BIOMETRIC_PATH}/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
